import { editableFieldsForNode } from "./module-builder-surface";
import { sortNodesForInsertDisplay } from "./module-insert-order";

const emptyGraph = { nodes: [], edges: [] };

export function recommendedInsertGroups(graph, t) {
  const nodes = sortNodesForInsertDisplay(
    graph?.nodes || emptyGraph.nodes,
    graph?.edges || emptyGraph.edges
  );
  return nodes
    .map((node) => {
      const lockedFields = node.data?.lockedFields || {};
      const fields = editableFieldsForNode(node, t).filter(
        (field) => lockedFields[field.key] !== true
      );
      const productsUnlocked =
        node.type === "productCatalog" && lockedFields.products !== true;
      if (fields.length === 0 && !productsUnlocked) return null;
      return { node, fields, productsUnlocked };
    })
    .filter(Boolean);
}

export function summarizeRecommendedInsertFields(graph, t) {
  return recommendedInsertGroups(graph, t)
    .flatMap(({ node, fields }) =>
      fields.map((field) => {
        const raw = node.data?.[field.key];
        if (raw == null || raw === "") return null;
        return `${field.label}: ${raw}`;
      })
    )
    .filter(Boolean)
    .join(" · ");
}

export function recommendedFieldsNeedAttention(graph, t) {
  const groups = recommendedInsertGroups(graph, t);
  if (!groups.length) return false;
  if (graph?.meta?.insert_confirmed_at) return false;
  return true;
}
